define(function(require,exports,module) {
    var tpl =   
                '<div class="history">'+
                    '<div class="head">最近浏览</div>'+
                    '<div class="items">'+
                        '<ul>'+
                            '<% for(var i=0; i<data.length; i++) { %>'+
                                '<li skuid="J_<%= data[i].skuid %>">'+ 
                                    '<a href="//item.jd.hk/<%=data[i].skuid%>.html" target="_blank">'+
                                        '<img data-original="<%= data[i].image %>' + '" src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" class="itemImg lazy">'+
                                    '</a>'+
                                    '<span class="detail">'+
                                        '<a href="//item.jd.hk/<%=data[i].skuid%>.html" target="_blank" class="name"><%= data[i].name %></a>'+
                                        '<span class="price">'+
                                            '<span></span>'+
                                        '</span>'+
                                    '</span>'+
                                '</li>'+
                              '<% } %>'+
                        '</ul>'+
                    '</div>'+
                '</div>';
    exports.tpl = tpl;
});


// WEBPACK FOOTER //
// ./src/js/template/indexV2RecmdLeft.js